export default "__VITE_ASSET__DwJCs4qt__"